import {HttpClient, HttpParams} from '@angular/common/http';
import {Inject, Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {REMIT_BASE_URL} from './config';

export interface StaffAuditLogQuery {
  page?: number;
  pageSize?: number;
  actorId?: string;
  requestId?: string;
  path?: string;
  method?: string;
  statusFrom?: number;
  clientIp?: string;
  from?: string;
  to?: string;
}

export interface StaffAuditLogEntry {
  id: string;
  requestId: string;
  actorId: string;
  method: string;
  path: string;
  rawPath: string;
  query: string;
  bodyHash: string;
  clientIp: string;
  userAgent: string;
  requestBodySize: number;
  bodyTruncated: boolean;
  statusCode: number;
  latencyMs: number;
  errorMessage: string;
  createdAt: string;
}

export interface StaffAuditLogResponseMeta {
  total: number;
  page: number;
  pageSize: number;
}

export interface StaffAuditLogResponse {
  data: StaffAuditLogEntry[];
  meta: StaffAuditLogResponseMeta;
}

@Injectable({
  providedIn: 'root',
})
export class StaffAuditLogService {
  constructor(
      private http: HttpClient,
      @Inject(REMIT_BASE_URL) private remitApiUrl: string,
  ) {}

  queryStaffAuditLogs(query: StaffAuditLogQuery): Observable<StaffAuditLogResponse> {
    let params = new HttpParams();

    Object.entries(query || {}).forEach(([key, value]) => {
      if (value === undefined || value === null || value === '') {
        return;
      }
      params = params.append(key, String(value));
    });

    return this.http.get<StaffAuditLogResponse>(
        `${this.remitApiUrl}/staff/audit/logs`,
        {params},
    );
  }
}

